export default "__VITE_PUBLIC_ASSET__3eb55a43__"